import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../assets/css/custom.css'

Vue.use(BootstrapVue)



// WEBPACK FOOTER //
// ./src/plugins/bootstrap-vue.js